import { Factory } from './factory';
import { ReadspeakerElement } from '../readerspeaker-element';
import { Position } from '../position';

export class ReadspeakerElementFactory implements Factory<ReadspeakerElement> {

    buildFromFactory(): ReadspeakerElement {
        return undefined;
    }

    buildFromObject(jsonObject: any): ReadspeakerElement {
        const readspeakerElement = new ReadspeakerElement();
        readspeakerElement.id = jsonObject.id;
        readspeakerElement.pageId = jsonObject.pageId;

        const position = new Position();
        position.x = +jsonObject.position.x;
        position.y = +jsonObject.position.y;
        position.w = +jsonObject.position.w;
        position.h = +jsonObject.position.h;

        const button = new Position();
        if (jsonObject.button.x !== null && jsonObject.button.y !== null) {
            button.x = +jsonObject.button.x;
            button.y = +jsonObject.button.y;
        } else {
            // Set this flag so the component knows these values have been overwritten. See #12191
            readspeakerElement.changedPosition = true;
            button.x = 100;
            button.y = 100;
        }

        readspeakerElement.button = button;
        readspeakerElement.position = position;
        readspeakerElement.texts = { current: jsonObject.texts.current, original: jsonObject.texts.original };
        readspeakerElement.enabled = jsonObject.active;

        return readspeakerElement;
    }

}
